import './QuizProgressBar.scss'

/**
 * Simple Quiz Progress Bar component. Used for displaying progress bars in quizzes
 * @param {Object} params Object containing progress bar config params
 */
export default function QuizProgressBar({
  total,
  completed = 0,
  hasSummary = false,
  showCount = true
}) {
  const progressColumns = () => {
    const columns = []

    for (let i = 0; i < total; i++) {
      let className = 'quiz-progress-bar-item '
      className += i < completed ? 'filled' : 'empty'
      columns.push(
        <div
          key={i}
          className={className}
          style={{ animationDelay: `${i * 0.1}s` }}
        ></div>
      )
    }

    return columns
  }

  return (
    <div className='quiz-progress-bar-wrapper'>
      <div className='quiz-progress-bar'>
        {showCount && (
          <div className='quiz-progress-bar-count'>
            {completed}/{total}
          </div>
        )}
        <div className='quiz-progress-bar-container'>
          {progressColumns().map(column => column)}
        </div>
      </div>
    </div>
  )
}
